module.exports = (__webpack_require__(2984))(4484);